import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import { useAlert } from "react-alert";
import auth from "../../../core/auth";
const appparameters = require("../../../core/common.jsx");

export const AddSite = (props) => {
  const alert = useAlert();
  const [loading, setLoading] = useStateIfMounted(false);
  const [state, setState] = useStateIfMounted({
    siteid: "",
    sitepass: "",
    location: "",
    latitude: "",
    longitude: "",
    description: "",
    mailonfault: false,
  });

  const history = useHistory();
  const handleClick = () => history.push("/");

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    let can_proceed = true;
    let siteidlen = 6;
    let passlen = 3;
    let idregex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/; ///^[A-Za-z0-9]*$/;
    //console.log("_"+state.siteid+"_len_"+state.siteid.length);
    if (state.siteid.length != siteidlen || !idregex.test(state.siteid)) {
      can_proceed = false;
      setLoading(false);
      setState({ ...state, siteid: "" });
      alert.show("Wrong site id format", { type: "error", position: "middle" });
      return;
    }
    if (state.sitepass.length != passlen) {
      can_proceed = false;
      setLoading(false);
      setState({ ...state, sitepass: "" });
      alert.show("Wrong password format", {
        type: "error",
        position: "middle",
      });
      return;
    }
    if (can_proceed) {
      let temp_state = { ...state, ...auth.getUserData() };

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(temp_state),
      };
      console.log(temp_state);
      fetch(appparameters.backend_app_url + "/frontend/addsite", requestOptions)
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData) {
            history.push("/grid");
            alert.show("Site added successfully", { type: "success" });
          } else {
            alert.show("Failed to add", { type: "error", position: "middle" });
          }
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    /*const savedtoken = localStorage.getItem("token");
    console.log("save token: "+savedtoken);
    console.log("user data");
    console.log(auth.getUserData());*/
  }, []);

  if (loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading site ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <form className="container" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>Site ID *</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroupPrepend2">
                    @
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Site id"
                  aria-describedby="inputGroupPrepend2"
                  value={state.siteid}
                  onChange={(e) =>
                    setState({ ...state, siteid: e.target.value })
                  }
                  required
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label>Site Password *</label>
              <input
                type="password"
                className="form-control"
                placeholder="Site password"
                value={state.sitepass}
                onChange={(e) =>
                  setState({ ...state, sitepass: e.target.value })
                }
                required
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label>Location</label>
              <input
                type="text"
                className="form-control"
                placeholder="Site location name"
                value={state.location}
                onChange={(e) =>
                  setState({ ...state, location: e.target.value })
                }
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Latitude Location (DD)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Site latitude location in decimal degrees (DD)"
                value={state.latitude}
                onChange={(e) =>
                  setState({ ...state, latitude: e.target.value })
                }
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Longitude Location (DD)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Site longitude location in decimal degrees (DD)"
                value={state.longitude}
                onChange={(e) =>
                  setState({ ...state, longitude: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label htmlFor="inputPassword">Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Description"
                value={state.description}
                onChange={(e) =>
                  setState({ ...state, description: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <div className="custom-control custom-switch">
              <input
                className="custom-control-input"
                type="checkbox"
                id="addsitecheckbox"
                onChange={() =>
                  setState({
                    ...state,
                    mailonfault: state.mailonfault == 0 ? 1 : 0,
                  })
                }
                checked={state.mailonfault > 0}
              />
              <label className="custom-control-label" htmlFor="addsitecheckbox">
                Sync this site with email
              </label>
            </div>
          </div>
          <div className="alert alert-info" role="alert">
            Site ID and password can be found in the device parameters. Latitude
            and longitude are required location parameters for displaying the
            map view. * required.
          </div>
          <button className="btn btn-primary" type="submit">
            Submit
          </button>
          &nbsp;
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClick}
          >
            Cancel
          </button>
        </form>
      </React.Fragment>
    );
  }
};
